import { motion } from "framer-motion";
import { ShieldCheck, Award, Users, Ruler } from "lucide-react";
import { useM2, fmtM2 } from "@/lib/stats";

const pillars = [
  { icon: ShieldCheck, n: "36", u: "mesiacov", t: "Záruka na prácu" },
  { icon: Award, n: "60", u: "mesiacov", t: "Záruka na materiál" },
  { icon: Ruler, n: "", u: "m²", t: "Zateplených fasád" },
  { icon: Users, n: "Overení", u: "partneri", t: "V každom okrese máme overených partnerov." },
];

export default function Trust() {
  const m2 = fmtM2(useM2());
  return (
    <section id="spolahlivost" className="bg-ink py-24 md:py-32 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-3xl mb-16">
          <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-5">Spoľahlivosť</p>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.9] text-white">
            Na nás sa môžete<br /><span className="text-gold">spoľahnúť</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg mt-6 max-w-xl leading-relaxed">
            Za viac ako {m2} m² zateplených fasád rodinných a bytových domov. Kvalitu potvrdzujeme
            zárukou 36 mesiacov na prácu a 60 mesiacov na materiál.
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {pillars.map((p, i) => {
            const Icon = p.icon;
            const num = p.u === "m²" ? `${m2}+` : p.n;
            return (
              <motion.div
                key={p.t}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="p-6 md:p-8 border border-white/10 bg-ink-2 hover:border-gold/40 transition-colors"
              >
                <Icon className="w-8 h-8 text-gold mb-6" />
                <div className="font-display text-4xl md:text-5xl text-white leading-none">{num}</div>
                <div className="font-mono2 text-gold text-xs uppercase tracking-widest mt-1">{p.u}</div>
                <div className="text-white/50 text-sm mt-3">{p.t}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
